import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, X, Download, FileDownIcon, DownloadIcon,  } from 'lucide-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MapComponent from '../Projectsfolder/NestComponent_Project/mapComponent_kml';
import ProjectPDFview from '../projectDetailComponent/projectPDFview';
import ProjectProjection from '../Projectsfolder/NestComponent_Project/projectProjection';
import { downloadProjectPDF } from '../Table/nestedcomponent/ProjectPDFDownloader';
// import { useNavigate } from "react-router-dom";
const Detail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const project = location.state?.project;
    const [showPdf, setShowPdf] = useState(false);
    const [pdfError, setPdfError] = useState(null);
    const pdfModalRef = useRef(null);

    // console.log(`This is project data ${JSON.stringify(project , null , " ")}`)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (pdfModalRef.current && !pdfModalRef.current.contains(event.target)) {
                setShowPdf(false);
                setPdfError(null);
            }
        };

        if (showPdf) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showPdf]);

    if (!project) {
        return <p className="text-xl text-gray-500">No project data available.</p>;
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString();
    };

    const formatCostInINR = (cost) => {
        const conversionRate = 83;
        const costInINR = cost * conversionRate;
        return costInINR.toLocaleString('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0,
        });
    };

    const handleViewDocument = () => {
        if (project.documentFile && project.documentFile[0]) {
            setPdfError(null);
            setShowPdf(true);
        } else {
            toast.error('No document available for this project', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
        }
    };

    const handleClosePdf = () => {
        setShowPdf(false);
        setPdfError(null);
    };

    const handlePdfError = (error) => {
        setPdfError('Failed to load PDF document. Please try again later.');
        console.error('PDF Error:', error);
    };

//    const navigate = useNavigate();

const handleDownloadPDF = async () => {
    try {
        // await downloadProjectPDF(project, formatDate, formatCostInINR);

        navigate("/management/viewCitydetail", {
            state: {
                cityname: project.city,
                statee: project.state,
                country: project.country,
                projectId:project._id,
                projectiondata:project.projection_id
            }
        });
    } catch (error) {
        toast.error("Failed to generate PDF. Please try again.", {
            position: "top-right",
            autoClose: 3000,
        });
        console.error("PDF Generation Error:", error);
    }
};


    return (
        <div className="w-full min-h-screen bg-gray-900" style={{
            overflow: 'auto',
            height: '100vh',
            width: '100%',
            scrollbarWidth: '1px',
            msOverflowStyle: 'none'
          }}> 
            <ToastContainer />
            <div className="p-4 sm:p-6">
                {/* Header Section */}
                <div className="flex items-center justify-between mb-6">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center px-4 py-2 text-white bg-gray-800 rounded-lg hover:bg-gray-700 transition-all"
                    >
                        <ArrowLeft className="mr-2" />
                        Back
                    </button>
                    <h1 className="text-2xl sm:text-3xl font-bold text-white text-center">
                        {project.project_name}
                    </h1>
                    <button
                        onClick={handleDownloadPDF}
                        className="flex items-center px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-all"
                    >
                        <DownloadIcon className="mr-2" size={18} />
                        Pre View
                    </button>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    {/* Left Side - Project Details Card */}
                    <div className="col-span-1">
                        <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg">
                            <div className="p-5 space-y-4">
                                {[
                                    { label: 'Sector', key: 'sector', },
                                    { label: 'Cost', key: 'cost' },
                                    { label: 'Status', key: 'status' },
                                    { label: 'Country', key: 'country', },
                                    { label: 'State', key: 'state' },
                                    { label: 'City', key: 'city', },
                                    { label: 'Start Date', key: 'startDate' },
                                    { label: 'End Date', key: 'endDate' },
                                    { label: 'Contractor', key: 'contractor' },
                                    { label: 'Registrar Office', key: 'district.registrarOffice', value: project?.district?.registrarOffice ?? 'Not Available' },
                                    { label: 'Circle Rate', key: 'district.circleRate', value: project?.district?.circleRate ?? "N/A" },
                                    { label: 'District Magistrate', key: 'district.districtMagistrate', value: project?.district?.districtMagistrate ?? "N/A" },
                                    { label: 'Population of District', key: 'district.population', value: project?.district?.population?.toLocaleString() ?? "N/A" },
                                ].map((field, index) => (
                                    <div key={index}>
                                        {field.isHeading ? (
                                            <h3 className="text-lg font-semibold text-blue-400 mt-4 mb-2">
                                                {field.label}: {project[field.key] || 'N/A'}
                                            </h3>
                                        ) : (
                                            <p className="text-gray-300">
                                                <span className="font-medium text-gray-400">{field.label}:</span>{" "}
                                                {field.value 
                                                    ? field.value
                                                    : field.key === 'cost'
                                                        ? formatCostInINR(project[field.key])
                                                        : field.key.includes('Date')
                                                            ? formatDate(project[field.key])
                                                            : project[field.key] || 'N/A'}
                                            </p>
                                        )}
                                        {index < 12 && <div className="border-t border-gray-700 mt-3"></div>}
                                    </div>
                                ))}
                            </div>
                            
                            <div className="px-5 pb-5">
                                <button
                                    onClick={handleViewDocument}
                                    className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 rounded-lg transition-all"
                                >
                                    View Document
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Right Side - Map */}
                    <div className="col-span-1 lg:col-span-2">
                        <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg h-full">
                            
                            <div className="h-full min-h-[500px] bg-gray-900 rounded-lg overflow-hidden">
  <MapComponent projectid={project._id} />
</div>

                        </div>
                    </div>
                </div>
            </div>

            {/* PDF Viewer Modal */}
            {showPdf && project.documentFile?.[0] && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-sm">
                    <div 
                        ref={pdfModalRef}
                        className="relative w-full max-w-5xl h-[90vh] bg-gray-800 rounded-xl shadow-2xl overflow-hidden flex flex-col border border-gray-700"
                    >
                        <div className="flex justify-between items-center p-4 bg-gray-900 border-b border-gray-700">
                            <h3 className="text-white font-semibold">
                                {project.project_name} - Document
                            </h3>
                            <button
                                onClick={handleClosePdf}
                                className="p-2 text-gray-400 hover:text-white rounded-full hover:bg-gray-700 transition-colors"
                            >
                                <X size={24} />
                            </button>
                        </div>
                        <div className="flex-1 w-full h-full overflow-auto">
                            {pdfError ? (
                                <div className="flex items-center justify-center h-full">
                                    <div className="text-white p-4 text-center">
                                        <p className="text-red-500 mb-4">{pdfError}</p>
                                        <button 
                                            onClick={handleClosePdf}
                                            className="px-4 py-2 bg-blue-600 rounded hover:bg-blue-700 transition-colors"
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="w-full h-full">
                                    <ProjectPDFview 
                                        pdfUrl={project.documentFile[0]} 
                                        onError={handlePdfError}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            <ProjectProjection projectiondata={project.projection_id} />
        </div>
    );
};

export default Detail;

// import React, { useState, useRef, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { ArrowLeft, X, Download } from 'lucide-react';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import MapComponent from '../Projectsfolder/NestComponent_Project/mapComponent_kml';
// import ProjectPDFview from '../projectDetailComponent/projectPDFview';
// import ProjectProjection from '../Projectsfolder/NestComponent_Project/projectProjection';
// import { jsPDF } from 'jspdf';
// import html2canvas from 'html2canvas';

// const Detail = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const project = location.state?.project;
//     const [showPdf, setShowPdf] = useState(false);
//     const [pdfError, setPdfError] = useState(null);
//     const pdfModalRef = useRef(null);
//     const projectDetailsRef = useRef(null);

//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (pdfModalRef.current && !pdfModalRef.current.contains(event.target)) {
//                 setShowPdf(false);
//                 setPdfError(null);
//             }
//         };

//         if (showPdf) {
//             document.addEventListener('mousedown', handleClickOutside);
//         } else {
//             document.removeEventListener('mousedown', handleClickOutside);
//         }

//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, [showPdf]);

//     if (!project) {
//         return <p className="text-xl text-gray-500">No project data available.</p>;
//     }

//     const formatDate = (dateString) => {
//         const date = new Date(dateString);
//         return date.toLocaleDateString();
//     };

//     const formatCostInINR = (cost) => {
//         const conversionRate = 83;
//         const costInINR = cost * conversionRate;
//         return costInINR.toLocaleString('en-IN', {
//             style: 'currency',
//             currency: 'INR',
//             maximumFractionDigits: 0,
//         });
//     };

//     const handleViewDocument = () => {
//         if (project.documentFile && project.documentFile[0]) {
//             setPdfError(null);
//             setShowPdf(true);
//         } else {
//             toast.error('No document available for this project', {
//                 position: "top-right",
//                 autoClose: 3000,
//                 hideProgressBar: false,
//                 closeOnClick: true,
//                 pauseOnHover: true,
//                 draggable: true,
//                 progress: undefined,
//                 theme: "dark",
//             });
//         }
//     };

//     const handleClosePdf = () => {
//         setShowPdf(false);
//         setPdfError(null);
//     };

//     const handlePdfError = (error) => {
//         setPdfError('Failed to load PDF document. Please try again later.');
//         console.error('PDF Error:', error);
//     };

//     const downloadProjectDetails = () => {
//         const doc = new jsPDF();
        
//         // Add project logo at the top
//         doc.addImage('http://13.202.13.248:3000/static/media/atom1.a701aa274e3a701996f2.png', 'PNG', 10, 10, 30, 20); // Adjust the position and size as needed
    
//         // Add stylish title
//         doc.setFontSize(22);
//         doc.setFont("helvetica", "bold");
//         doc.text(`Project Details: ${project.project_name}`, 105, 20, { align: 'center' });
        
//         // Add a separator line under the title for better design
//         doc.setLineWidth(0.5);
//         doc.line(10, 30, 200, 30);
    
//         // Add "Project Overview" header
//         doc.setFontSize(14);
//         doc.setFont("helvetica", "bold");
//         doc.text("Project Overview", 15, 40);
        
//         // Add basic information in a clean, structured format
//         doc.setFontSize(12);
//         doc.setFont("helvetica", "normal");
//         let yPosition = 50;
//         const fields = [
//             { label: 'Sector', value: project.sector || 'N/A' },
//             { label: 'Cost', value: formatCostInINR(project.cost) },
//             { label: 'Status', value: project.status || 'N/A' },
//             { label: 'Country', value: project.country || 'N/A' },
//             { label: 'State', value: project.state || 'N/A' },
//             { label: 'City', value: project.city || 'N/A' },
//             { label: 'Start Date', value: formatDate(project.startDate) },
//             { label: 'End Date', value: formatDate(project.endDate) },
//             { label: 'Contractor', value: project.contractor || 'N/A' },
//             { label: 'Registrar Office', value: project?.district?.registrarOffice ?? 'N/A' },
//             { label: 'Circle Rate', value: project?.district?.circleRate ?? "N/A" },
//             { label: 'District Magistrate', value: project?.district?.districtMagistrate ?? "N/A" },
//             { label: 'Population of District', value: project?.district?.population?.toLocaleString() ?? "N/A" },
//         ];
    
//         fields.forEach(field => {
//             doc.text(`${field.label}:`, 15, yPosition);
//             doc.text(`${field.value}`, 70, yPosition);
//             yPosition += 10;
    
//             // Add new page if content is too long
//             if (yPosition > 270) {
//                 doc.addPage();
//                 yPosition = 20;
//             }
//         });
    
//         // Optional: Add a section for more details (e.g., project timeline, images, etc.)
//         // Example: Timeline section
//         doc.addPage();
//         doc.setFontSize(14);
//         doc.setFont("helvetica", "bold");
//         doc.text("Project Timeline", 15, 20);
//         doc.setFontSize(12);
//         doc.setFont("helvetica", "normal");
//         doc.text(`Start Date: ${formatDate(project.startDate)}`, 15, 40);
//         doc.text(`End Date: ${formatDate(project.endDate)}`, 15, 50);
//         // Add any other project details here
    
//         // Save the PDF with a more appealing filename
//         doc.save(`${project.project_name.replace(/\s+/g, '_')}_Details.pdf`);
//     };
    

//     return (
//         <div className="w-full min-h-screen bg-gray-900" style={{
//             overflow: 'auto',
//             height: '100vh',
//             width: '100%',
//             scrollbarWidth: '1px',
//             msOverflowStyle: 'none'
//           }}> 
//             <ToastContainer />
//             <div className="p-4 sm:p-6">
//                 {/* Header Section */}
//                 <div className="flex items-center justify-between mb-6">
//                     <button
//                         onClick={() => navigate(-1)}
//                         className="flex items-center px-4 py-2 text-white bg-gray-800 rounded-lg hover:bg-gray-700 transition-all"
//                     >
//                         <ArrowLeft className="mr-2" />
//                         Back
//                     </button>
//                     <h1 className="text-2xl sm:text-3xl font-bold text-white text-center">
//                         {project.project_name}
//                     </h1>
//                     <button
//                         onClick={downloadProjectDetails}
//                         className="flex items-center px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-all"
//                     >
//                         <Download className="mr-2" size={18} />
//                         Download
//                     </button>
//                 </div>

//                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" ref={projectDetailsRef}>
//                     {/* Left Side - Project Details Card */}
//                     <div className="col-span-1">
//                         <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg">
//                             <div className="p-5 space-y-4">
//                                 {[
//                                     { label: 'Sector', key: 'sector', },
//                                     { label: 'Cost', key: 'cost' },
//                                     { label: 'Status', key: 'status' },
//                                     { label: 'Country', key: 'country', },
//                                     { label: 'State', key: 'state' },
//                                     { label: 'City', key: 'city', },
//                                     { label: 'Start Date', key: 'startDate' },
//                                     { label: 'End Date', key: 'endDate' },
//                                     { label: 'Contractor', key: 'contractor' },
//                                     { label: 'Registrar Office', key: 'district.registrarOffice', value: project?.district?.registrarOffice ?? 'Not Available' },
//                                     { label: 'Circle Rate', key: 'district.circleRate', value: project?.district?.circleRate ?? "N/A" },
//                                     { label: 'District Magistrate', key: 'district.districtMagistrate', value: project?.district?.districtMagistrate ?? "N/A" },
//                                     { label: 'Population of District', key: 'district.population', value: project?.district?.population?.toLocaleString() ?? "N/A" },
//                                 ].map((field, index) => (
//                                     <div key={index}>
//                                         {field.isHeading ? (
//                                             <h3 className="text-lg font-semibold text-blue-400 mt-4 mb-2">
//                                                 {field.label}: {project[field.key] || 'N/A'}
//                                             </h3>
//                                         ) : (
//                                             <p className="text-gray-300">
//                                                 <span className="font-medium text-gray-400">{field.label}:</span>{" "}
//                                                 {field.value 
//                                                     ? field.value
//                                                     : field.key === 'cost'
//                                                         ? formatCostInINR(project[field.key])
//                                                         : field.key.includes('Date')
//                                                             ? formatDate(project[field.key])
//                                                             : project[field.key] || 'N/A'}
//                                             </p>
//                                         )}
//                                         {index < 12 && <div className="border-t border-gray-700 mt-3"></div>}
//                                     </div>
//                                 ))}
//                             </div>
                            
//                             <div className="px-5 pb-5">
//                                 <button
//                                     onClick={handleViewDocument}
//                                     className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 rounded-lg transition-all"
//                                 >
//                                     View Document
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Right Side - Map */}
//                     <div className="col-span-1 lg:col-span-2">
//                         <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg h-full">
//                             <div className="h-full min-h-[500px] bg-gray-900 rounded-lg overflow-hidden">
//                                 <MapComponent projectid={project._id} />
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* PDF Viewer Modal */}
//             {showPdf && project.documentFile?.[0] && (
//                 <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-sm">
//                     <div 
//                         ref={pdfModalRef}
//                         className="relative w-full max-w-5xl h-[90vh] bg-gray-800 rounded-xl shadow-2xl overflow-hidden flex flex-col border border-gray-700"
//                     >
//                         <div className="flex justify-between items-center p-4 bg-gray-900 border-b border-gray-700">
//                             <h3 className="text-white font-semibold">
//                                 {project.project_name} - Document
//                             </h3>
//                             <button
//                                 onClick={handleClosePdf}
//                                 className="p-2 text-gray-400 hover:text-white rounded-full hover:bg-gray-700 transition-colors"
//                             >
//                                 <X size={24} />
//                             </button>
//                         </div>
//                         <div className="flex-1 w-full h-full overflow-auto">
//                             {pdfError ? (
//                                 <div className="flex items-center justify-center h-full">
//                                     <div className="text-white p-4 text-center">
//                                         <p className="text-red-500 mb-4">{pdfError}</p>
//                                         <button 
//                                             onClick={handleClosePdf}
//                                             className="px-4 py-2 bg-blue-600 rounded hover:bg-blue-700 transition-colors"
//                                         >
//                                             Close
//                                         </button>
//                                     </div>
//                                 </div>
//                             ) : (
//                                 <div className="w-full h-full">
//                                     <ProjectPDFview 
//                                         pdfUrl={project.documentFile[0]} 
//                                         onError={handlePdfError}
//                                     />
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}
//             <ProjectProjection/>
//         </div>
//     );
// };

// export default Detail;


// above code also working ......... 
// import React, { useState, useRef, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { ArrowLeft, X } from 'lucide-react';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import MapComponent from '../Projectsfolder/NestComponent_Project/mapComponent_kml';
// import ProjectPDFview from '../projectDetailComponent/projectPDFview';
// import ProjectProjection from '../Projectsfolder/NestComponent_Project/projectProjection';

// const Detail = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const project = location.state?.project;
//     const [showPdf, setShowPdf] = useState(false);
//     const [pdfError, setPdfError] = useState(null);
//     const pdfModalRef = useRef(null);

//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (pdfModalRef.current && !pdfModalRef.current.contains(event.target)) {
//                 setShowPdf(false);
//                 setPdfError(null);
//             }
//         };

//         if (showPdf) {
//             document.addEventListener('mousedown', handleClickOutside);
//         } else {
//             document.removeEventListener('mousedown', handleClickOutside);
//         }

//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, [showPdf]);

//     if (!project) {
//         return <p className="text-xl text-gray-500">No project data available.</p>;
//     }

//     const formatDate = (dateString) => {
//         const date = new Date(dateString);
//         return date.toLocaleDateString();
//     };

//     const formatCostInINR = (cost) => {
//         const conversionRate = 83;
//         const costInINR = cost * conversionRate;
//         return costInINR.toLocaleString('en-IN', {
//             style: 'currency',
//             currency: 'INR',
//             maximumFractionDigits: 0,
//         });
//     };

//     const handleViewDocument = () => {
//         if (project.documentFile && project.documentFile[0]) {
//             setPdfError(null);
//             setShowPdf(true);
//         } else {
//             toast.error('No document available for this project', {
//                 position: "top-right",
//                 autoClose: 3000,
//                 hideProgressBar: false,
//                 closeOnClick: true,
//                 pauseOnHover: true,
//                 draggable: true,
//                 progress: undefined,
//                 theme: "dark",
//             });
//         }
//     };

//     const handleClosePdf = () => {
//         setShowPdf(false);
//         setPdfError(null);
//     };

//     const handlePdfError = (error) => {
//         setPdfError('Failed to load PDF document. Please try again later.');
//         console.error('PDF Error:', error);
//     };

//     return (
//         <div className="w-full min-h-screen bg-gray-900" style={{
//             overflow: 'auto',
//             height: '100vh',
//             width: '100%',
//             scrollbarWidth: '1px',
//             msOverflowStyle: 'none'
//           }}> 
//             <ToastContainer />
//             <div className="p-4 sm:p-6">
//                 {/* Header Section */}
//                 <div className="flex items-center justify-between mb-6">
//                     <button
//                         onClick={() => navigate(-1)}
//                         className="flex items-center px-4 py-2 text-white bg-gray-800 rounded-lg hover:bg-gray-700 transition-all"
//                     >
//                         <ArrowLeft className="mr-2" />
//                         Back
//                     </button>
//                     <h1 className="text-2xl sm:text-3xl font-bold text-white text-center">
//                         {project.project_name}
//                     </h1>
//                     <div className="w-10"></div> {/* Spacer for alignment */}
//                 </div>

//                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//                     {/* Left Side - Project Details Card */}
//                     <div className="col-span-1">
//                         <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg">
//                             <div className="p-5 space-y-4">
//                                 {[
//                                     { label: 'Sector', key: 'sector', },
//                                     { label: 'Cost', key: 'cost' },
//                                     { label: 'Status', key: 'status' },
//                                     { label: 'Country', key: 'country', },
//                                     { label: 'State', key: 'state' },
//                                     { label: 'City', key: 'city', },
//                                     { label: 'Start Date', key: 'startDate' },
//                                     { label: 'End Date', key: 'endDate' },
//                                     { label: 'Contractor', key: 'contractor' },
//                                     { label: 'Registrar Office', key: 'district.registrarOffice', value: project?.district?.registrarOffice ?? 'Not Available' },
//                                     { label: 'Circle Rate', key: 'district.circleRate', value: project?.district?.circleRate ?? "N/A" },
//                                     { label: 'District Magistrate', key: 'district.districtMagistrate', value: project?.district?.districtMagistrate ?? "N/A" },
//                                     { label: 'Population of District', key: 'district.population', value: project?.district?.population?.toLocaleString() ?? "N/A" },
//                                 ].map((field, index) => (
//                                     <div key={index}>
//                                         {field.isHeading ? (
//                                             <h3 className="text-lg font-semibold text-blue-400 mt-4 mb-2">
//                                                 {field.label}: {project[field.key] || 'N/A'}
//                                             </h3>
//                                         ) : (
//                                             <p className="text-gray-300">
//                                                 <span className="font-medium text-gray-400">{field.label}:</span>{" "}
//                                                 {field.value 
//                                                     ? field.value
//                                                     : field.key === 'cost'
//                                                         ? formatCostInINR(project[field.key])
//                                                         : field.key.includes('Date')
//                                                             ? formatDate(project[field.key])
//                                                             : project[field.key] || 'N/A'}
//                                             </p>
//                                         )}
//                                         {index < 12 && <div className="border-t border-gray-700 mt-3"></div>}
//                                     </div>
//                                 ))}
//                             </div>
                            
//                             <div className="px-5 pb-5">
//                                 <button
//                                     onClick={handleViewDocument}
//                                     className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 rounded-lg transition-all"
//                                 >
//                                     View Document
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Right Side - Map */}
//                     <div className="col-span-1 lg:col-span-2">
//                         <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg h-full">
//                             <div className="h-full min-h-[500px] bg-gray-900 rounded-lg overflow-hidden">
//                                 <MapComponent projectid={project._id} />
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* PDF Viewer Modal */}
//             {showPdf && project.documentFile?.[0] && (
//                 <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-sm">
//                     <div 
//                         ref={pdfModalRef}
//                         className="relative w-full max-w-5xl h-[90vh] bg-gray-800 rounded-xl shadow-2xl overflow-hidden flex flex-col border border-gray-700"
//                     >
//                         <div className="flex justify-between items-center p-4 bg-gray-900 border-b border-gray-700">
//                             <h3 className="text-white font-semibold">
//                                 {project.project_name} - Document
//                             </h3>
//                             <button
//                                 onClick={handleClosePdf}
//                                 className="p-2 text-gray-400 hover:text-white rounded-full hover:bg-gray-700 transition-colors"
//                             >
//                                 <X size={24} />
//                             </button>
//                         </div>
//                         <div className="flex-1 w-full h-full overflow-auto">
//                             {pdfError ? (
//                                 <div className="flex items-center justify-center h-full">
//                                     <div className="text-white p-4 text-center">
//                                         <p className="text-red-500 mb-4">{pdfError}</p>
//                                         <button 
//                                             onClick={handleClosePdf}
//                                             className="px-4 py-2 bg-blue-600 rounded hover:bg-blue-700 transition-colors"
//                                         >
//                                             Close
//                                         </button>
//                                     </div>
//                                 </div>
//                             ) : (
//                                 <div className="w-full h-full">
//                                     <ProjectPDFview 
//                                         pdfUrl={project.documentFile[0]} 
//                                         onError={handlePdfError}
//                                     />
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}
//             <ProjectProjection/>
//         </div>
//     );
// };

// export default Detail;



// import React from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { ArrowLeft } from 'lucide-react';
// import MapComponent from '../Projectsfolder/NestComponent_Project/mapComponent_kml';

// const Detail = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const project = location.state?.project;
//     // console.log(`this is project id ${project}`)

//     // Log project data for debugging
//     // console.log("Project Data:", project);

//     if (!project) {
//         return <p className="text-xl text-gray-500">No project data available.</p>;
//     }

//     // Function to format dates
//     const formatDate = (dateString) => {
//         const date = new Date(dateString);
//         return date.toLocaleDateString(); // Format as per locale
//     };

//     return (
//         <div className="w-full h-screen overflow-y-scroll scrollbar-hide bg-gray-50">
//             <div className="p-4 sm:p-8">
//                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//                     {/* Left Side - Project Details */}
//                     <div className="col-span-1">
//                         <button
//                             onClick={() => navigate(-1)}
//                             className="flex items-center mb-6 px-4 py-2 text-gray-700 font-bold bg-white rounded-lg shadow-sm hover:bg-gray-100 hover:shadow-md transition-all"
//                         >
//                             <ArrowLeft className="mr-2" />
//                             Back
//                         </button>

//                         <h1 className="text-3xl font-bold text-gray-900 mb-6">
//                             {project.project_name}
//                         </h1>

//                         <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-all">
//                             {[
//                                 { label: 'Sector', key: 'sector' },
//                                 { label: 'Cost', key: 'cost' },
//                                 { label: 'Status', key: 'status' },
//                                 { label: 'Country', key: 'country' },
//                                 { label: 'State', key: 'state' },
//                                 { label: 'City', key: 'city' },
//                                 { label: 'Start Date', key: 'startDate' },
//                                 { label: 'End Date', key: 'endDate' },
//                             ].map((field, index) => (
//                                 <div key={index} className="mb-4">
//                                     <p className="text-gray-600 font-medium">
//                                         <strong>{field.label}:</strong> {field.key.includes('Date') ? formatDate(project[field.key]) : project[field.key]}
//                                     </p>
//                                     <div className="border-t border-gray-200 mt-2"></div>
//                                 </div>
//                             ))}

//                             <button
//                                 className="mt-6 w-full bg-blue-500 text-white font-bold py-2 rounded-lg shadow-sm hover:bg-blue-600 hover:shadow-md transition-all"
//                             >
//                                 View Document
//                             </button>
//                         </div>
//                     </div>

//                     {/* Right Side - Map and Additional Info */}
//                     <div className="col-span-1 lg:col-span-2">
//                         <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-all">
//                             <div className="h-48 sm:h-64 md:h-96 bg-gray-100 rounded-lg flex items-center justify-center text-gray-500">
//                                 {/* <p className="text-xl">Map Placeholder</p> */}
//                                 <MapComponent projectid={project._id} />
//                             </div>
//                         </div>

//                         <div className="mt-8">
//                             <div className="w-full sm:w-3/4 md:w-1/2 bg-white p-6 rounded-lg shadow-sm">
//                                 <p className="text-gray-600 font-medium mt-2">
//                                     <strong>Registrar Office:</strong> Sector 44, Gurugram
//                                 </p>
//                                 <p className="text-gray-600 font-medium mt-2">
//                                     <strong>Circle Rate:</strong> $100/sq.ft
//                                 </p>
//                                 <p className="text-gray-600 font-medium mt-2">
//                                     <strong>District Magistrate:</strong> Mr. John Doe
//                                 </p>
//                                 <p className="text-gray-600 font-medium mt-2">
//                                     <strong>Population of District:</strong> 1.2 million
//                                 </p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Detail;



// import React from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { ArrowLeft } from 'lucide-react';
// import MapComponent from '../Projectsfolder/NestComponent_Project/mapComponent_kml';

// const Detail = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const project = location.state?.project;

//     if (!project) {
//         return <p className="text-xl text-gray-500">No project data available.</p>;
//     }

//     // Function to format dates
//     const formatDate = (dateString) => {
//         const date = new Date(dateString);
//         return date.toLocaleDateString(); // Format as per locale
//     };

//     // Function to format cost in Indian Rupees
//     const formatCostInINR = (cost) => {
//         const conversionRate = 83; // 1 USD = 83 INR (adjust as needed)
//         const costInINR = cost * conversionRate;
//         return costInINR.toLocaleString('en-IN', {
//             style: 'currency',
//             currency: 'INR',
//             maximumFractionDigits: 0, // Remove decimal places
//         });
//     };

//     return (
//         <div className="w-full h-screen overflow-y-scroll scrollbar-hide bg-gray-50">
//             <div className="p-4 sm:p-8">
//                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//                     {/* Left Side - Project Details */}
//                     <div className="col-span-1">
//                         <button
//                             onClick={() => navigate(-1)}
//                             className="flex items-center mb-6 px-4 py-2 text-gray-700 font-bold bg-white rounded-lg shadow-sm hover:bg-gray-100 hover:shadow-md transition-all"
//                         >
//                             <ArrowLeft className="mr-2" />
//                             Back
//                         </button>

//                         <h1 className="text-3xl font-bold text-gray-900 mb-6">
//                             {project.project_name}
//                         </h1>

//                         <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-all">
//                             {[
//                                 { label: 'Sector', key: 'sector' },
//                                 { label: 'Cost', key: 'cost' },
//                                 { label: 'Status', key: 'status' },
//                                 { label: 'Country', key: 'country' },
//                                 { label: 'State', key: 'state' },
//                                 { label: 'City', key: 'city' },
//                                 { label: 'Start Date', key: 'startDate' },
//                                 { label: 'End Date', key: 'endDate' },
//                             ].map((field, index) => (
//                                 <div key={index} className="mb-4">
//                                     <p className="text-gray-600 font-medium">
//                                         <strong>{field.label}:</strong>{" "}
//                                         {field.key === 'cost'
//                                             ? formatCostInINR(project[field.key]) // Format cost in INR
//                                             : field.key.includes('Date')
//                                             ? formatDate(project[field.key])
//                                             : project[field.key]}
//                                     </p>
//                                     <div className="border-t border-gray-200 mt-2"></div>
//                                 </div>
//                             ))}

//                             <button
//                                 className="mt-6 w-full bg-blue-500 text-white font-bold py-2 rounded-lg shadow-sm hover:bg-blue-600 hover:shadow-md transition-all"
//                             >
//                                 View Document
//                             </button>
//                         </div>
//                     </div>

//                     {/* Right Side - Map and Additional Info */}
//                     <div className="col-span-1 lg:col-span-2">
//                         <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-all">
//                             <div className="h-48 sm:h-64 md:h-96 bg-gray-100 rounded-lg flex items-center justify-center text-gray-500">
//                                 <MapComponent projectid={project._id} />
//                             </div>
//                         </div>

//                         <div className="mt-8">
//                             <div className="w-full sm:w-3/4 md:w-1/2 bg-white p-6 rounded-lg shadow-sm">
//                                 <p className="text-gray-600 font-medium mt-2">
//                                     <strong>Registrar Office:</strong> Sector 44, Gurugram
//                                 </p>
//                                 <p className="text-gray-600 font-medium mt-2">
//                                     <strong>Circle Rate:</strong> $100/sq.ft
//                                 </p>
//                                 <p className="text-gray-600 font-medium mt-2">
//                                     <strong>District Magistrate:</strong> Mr. John Doe
//                                 </p>
//                                 <p className="text-gray-600 font-medium mt-2">
//                                     <strong>Population of District:</strong> 1.2 million
//                                 </p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Detail;



// import React, { useState, useRef, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { ArrowLeft, X } from 'lucide-react';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import MapComponent from '../Projectsfolder/NestComponent_Project/mapComponent_kml';
// import ProjectPDFview from '../projectDetailComponent/projectPDFview';

// const Detail = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const project = location.state?.project;
//     const [showPdf, setShowPdf] = useState(false);
//     const [pdfError, setPdfError] = useState(null);
//     const pdfModalRef = useRef(null);

//     // Close PDF when clicking outside
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (pdfModalRef.current && !pdfModalRef.current.contains(event.target)) {
//                 setShowPdf(false);
//                 setPdfError(null);
//             }
//         };

//         if (showPdf) {
//             document.addEventListener('mousedown', handleClickOutside);
//         } else {
//             document.removeEventListener('mousedown', handleClickOutside);
//         }

//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, [showPdf]);

//     if (!project) {
//         return <p className="text-xl text-gray-500">No project data available.</p>;
//     }

//     // Function to format dates
//     const formatDate = (dateString) => {
//         const date = new Date(dateString);
//         return date.toLocaleDateString();
//     };

//     // Function to format cost in Indian Rupees
//     const formatCostInINR = (cost) => {
//         const conversionRate = 83;
//         const costInINR = cost * conversionRate;
//         return costInINR.toLocaleString('en-IN', {
//             style: 'currency',
//             currency: 'INR',
//             maximumFractionDigits: 0,
//         });
//     };

//     const handleViewDocument = () => {
//         if (project.documentFile && project.documentFile[0]) {
//             setPdfError(null);
//             setShowPdf(true);
//         } else {
//             toast.error('No document available for this project', {
//                 position: "top-right",
//                 autoClose: 3000,
//                 hideProgressBar: false,
//                 closeOnClick: true,
//                 pauseOnHover: true,
//                 draggable: true,
//                 progress: undefined,
//                 theme: "dark",
//             });
//         }
//     };

//     const handleClosePdf = () => {
//         setShowPdf(false);
//         setPdfError(null);
//     };

//     const handlePdfError = (error) => {
//         setPdfError('Failed to load PDF document. Please try again later.');
//         console.error('PDF Error:', error);
//     };

//     return (
//         <div className="w-full h-screen overflow-y-scroll scrollbar-hide bg-gray-900">
//             <ToastContainer />
//             <div className="p-4 sm:p-8">
//                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//                     {/* Left Side - Project Details */}
//                     <div className="col-span-1">
//                         <button
//                             onClick={() => navigate(-1)}
//                             className="flex items-center mb-6 px-4 py-2 text-white font-bold bg-gray-800 rounded-lg shadow-sm hover:bg-gray-700 hover:shadow-md transition-all"
//                         >
//                             <ArrowLeft className="mr-2" />
//                             Back
//                         </button>

//                         <h1 className="text-3xl font-bold text-white mb-6">
//                             {project.project_name}
//                         </h1>

//                         <div className="bg-gray-900 border text-white p-6 rounded-lg shadow-sm hover:shadow-md transition-all">
//                             {[
//                                 { label: 'Sector', key: 'sector' },
//                                 { label: 'Cost', key: 'cost' },
//                                 { label: 'Status', key: 'status' },
//                                 { label: 'Country', key: 'country' },
//                                 { label: 'State', key: 'state' },
//                                 { label: 'City', key: 'city' },
//                                 { label: 'Start Date', key: 'startDate' },
//                                 { label: 'End Date', key: 'endDate' },
//                                 { label: 'contractor', key: 'contractor' },
//                             ].map((field, index) => (
//                                 <div key={index} className="mb-4">
//                                     <p className="text-white font-medium">
//                                         <strong>{field.label}:</strong>{" "}
//                                         {field.key === 'cost'
//                                             ? formatCostInINR(project[field.key])
//                                             : field.key.includes('Date')
//                                                 ? formatDate(project[field.key])
//                                                 : project[field.key]}
//                                     </p>
//                                     <div className="border-t border-gray-200 mt-2"></div>
//                                 </div>
//                             ))}

//                             <button
//                                 onClick={handleViewDocument}
//                                 className="mt-6 w-full bg-blue-500 text-white font-bold py-2 rounded-lg shadow-sm hover:bg-blue-600 hover:shadow-md transition-all"
//                             >
//                                 View Document
//                             </button>
//                         </div>
//                     </div>

//                     {/* Right Side - Map and Additional Info */}
//                     <div className="col-span-1 lg:col-span-2">
//                         <div className="bg-gray-900 p-6 rounded-lg shadow-sm hover:shadow-md transition-all">
//                             <div className="h-48 sm:h-64 md:h-96 bg-gray-100 rounded-lg flex items-center justify-center text-gray-500">
//                                 <MapComponent projectid={project._id} />
//                             </div>
//                         </div>

//                         <div className="mt-8">
//                             <div className="w-full sm:w-3/4 md:w-1/2 bg-gray-900 border p-6 rounded-lg shadow-sm">
//                                 <p className="text-white border-b font-medium mt-2">
//                                     <strong>Registrar Office:</strong> {project?.district?.registrarOffice ?? 'Not Available'}
//                                 </p>
//                                 <p className="text-white border-b font-medium mt-2">
//                                     <strong>Circle Rate:</strong> {project?.district?.circleRate ?? "N/A"}
//                                 </p>
//                                 <p className="text-white border-b font-medium mt-2">
//                                     <strong>District Magistrate:</strong> {project?.district?.districtMagistrate ?? "N/A"}
//                                 </p>
//                                 <p className="text-white border-b font-medium mt-2">
//                                     <strong>Population of District:</strong> {project?.district?.population?.toLocaleString() ?? "N/A"}
//                                 </p>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Improved PDF Viewer Modal */}
//                     {showPdf && project.documentFile?.[0] && (
//                         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-sm">
//                             <div 
//                                 ref={pdfModalRef}
//                                 className="relative w-full max-w-5xl h-[90vh] bg-gray-800 rounded-xl shadow-2xl overflow-hidden flex flex-col"
//                             >
//                                 <div className="flex justify-between items-center p-4 bg-gray-900 border-b border-gray-700">
//                                     <h3 className="text-white font-semibold">
//                                         {project.project_name} - Document
//                                     </h3>
//                                     <button
//                                         onClick={handleClosePdf}
//                                         className="p-2 text-gray-400 hover:text-white rounded-full hover:bg-gray-700 transition-colors"
//                                     >
//                                         <X size={24} />
//                                     </button>
//                                 </div>
//                                 <div className="flex-1 w-full h-full overflow-auto">
//                                     {pdfError ? (
//                                         <div className="flex items-center justify-center h-full">
//                                             <div className="text-white p-4 text-center">
//                                                 <p className="text-red-500 mb-4">{pdfError}</p>
//                                                 <button 
//                                                     onClick={handleClosePdf}
//                                                     className="px-4 py-2 bg-blue-500 rounded hover:bg-blue-600 transition-colors"
//                                                 >
//                                                     Close
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     ) : (
//                                         <div className="w-full h-full">
//                                             <ProjectPDFview 
//                                                 pdfUrl={project.documentFile[0]} 
//                                                 onError={handlePdfError}
//                                             />
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Detail;



